/**
 * Translated version of friendlyTimeFormatter.
 *
 * This wraps the i18n helpers to produce localized, pluralized human time strings
 * with the same behavior and fallbacks as the original friendlyTimeFormatter.
 */
import { formatTimeWithSuffix, translateHumanTime, ReactI18nextTranslationFunction } from './coreTranslationHelpers';
import { getTimestamp, TIMES } from '../timeUtil';
import dateformat from 'dateformat';

export default ({
    t,
    timestamp,
    fromTimestamp = getTimestamp(),
    lessThanMinuteMessage,
    showSuffix,
}: {
    t: ReactI18nextTranslationFunction;
    timestamp: number;
    fromTimestamp?: number;
    lessThanMinuteMessage?: string;
    showSuffix?: boolean;
}): string => {
    const millisPassed = fromTimestamp - timestamp;

    // If less than a minute just show this string. If a custom message is
    // provided prefer it; otherwise fall back to translateHumanTime's justNow.
    if (millisPassed > 0 && millisPassed < TIMES.MINUTE) {
        if (lessThanMinuteMessage) return lessThanMinuteMessage;
        return translateHumanTime(t, 0);
    }

    // If more than 4 weeks old, use the actual date E.g. 1 Jan 2017
    if (Math.abs(millisPassed) > 4 * TIMES.WEEK) return dateformat(timestamp, 'd mmm yyyy');

    // Use the i18n helpers which return translated, pluralized time and optional suffix
    if (typeof showSuffix === 'undefined') showSuffix = true;

    // formatTimeWithSuffix uses translateHumanTime internally and will add suffixes
    return formatTimeWithSuffix(t, millisPassed / 1000, showSuffix);
};
